import useGetRewards from './useGetRewards'

export default useGetRewards
